
import React, { useState, useEffect, useContext } from "react";
import Header from "../../components/dashboard/header";
import Sidebar from "../../components/dashboard/sidebar";
import { useNavigate, Link } from "react-router-dom";
import { useParams } from 'react-router-dom';
import SideMenu from "../student/SideMenu";
import EditorEdit from "./EditorEdit.js";
import axios from 'axios';
import Select from 'react-select';
import CreatableSelect from 'react-select/creatable';
import Loader from "../../components/loader";
import SessionPopup from "../SessionPopup";
import SweetAlert from 'react-bootstrap-sweetalert';
import { contentContext } from "../../context/contentContext";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import rotate_right from '../../assets/images/rotate_right.svg';
import ValuesDropdown from './ValuesDropdown.js';
let { lambda, appname } = window.app;
const SELECT_ALL_VALUE = "__select_all__";
const USERTYPE_OPTIONS = [
];

const EditEmailTemplate = () => {
    let { id } = useParams();
    const navigate = useNavigate();
    const [msg, setMsg] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [emailError, setEmailError] = useState('');
    const [nameError, setNameError] = useState('');
    const [phoneError, setPhoneError] = useState('');
    const [success, setSuccess] = useState(false);
    const [IdcError, setIdcError] = useState('');
    const [typeError, setTypeError] = useState('');
    const [contentError, setContentError] = useState('');
    const [toastMessage, setToastMessage] = useState(""); // State for dynamic message
    const [editUser, setEditUser] = useState({ name: '', phone: '', userType: '', status: '', emailid: '' });
    const [permission, setPermission] = useState({});
    const [UpdateSuccess, setUpdateSuccess] = useState(false);
    const [image, setImg] = useState('');
    const [manager, setManagers] = useState({});
    const [selectAll, setSelectAll] = useState(false);
    const [recipientOptions, setRecipientOptions] = useState([]);
    const [selectedRecipients, setSelectedRecipients] = useState([]);
    const [selectedUserTypes, setSelectedUserTypes] = useState([]);
    const [existmsg, setExistMsg] = useState(false);
    const [showSessionPopupup, setShowSessionPopupup] = useState(false);
    const [Ismsg, setIsMsg] = useState(false);
    const [checkStatus, setCheckStatus] = useState(false);
    const [invalidContent, setInvalidContent] = useState(false);
    const { route, setRoute, setCurrentPage, setRowsPerPage, setActiveMenuObj, usePrevious, userData, setActiveMenuId, GetTimeActivity } = useContext(contentContext);
     const [content, setContent] = useState('');
       const [formValuesOption, setFormValuesOption] = useState(null);
  const [valueDependency, setValuesDependency] = useState(0);

    const prevRoute = usePrevious(route)
    useEffect(() => {
        if (prevRoute !== undefined && prevRoute !== route) {
            setCurrentPage(1)
            setRowsPerPage(15)
        }
    }, [prevRoute]);
    useEffect(() => {

        if (window.site === undefined) {
            setTimeout(() => {
                if (window.site && window.site.common && window.site.common.imageCloudfront) {
                    setImg(window.site.common.imageCloudfront)
                }
            }, 1000);
        }
        if (window.site && window.site.common && window.site.common.imageCloudfront) {
            setImg(window.site.common.imageCloudfront)
        }


    }, [window.site]);

    useEffect(() => {
        if (toastMessage) {
            toast.success(toastMessage, {
                position: "bottom-center",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });

            // Clear the message after showing to prevent re-triggering
            setToastMessage("");
        }
    }, [toastMessage]);

    useEffect(() => {
        if (!localStorage.getItem("token")) {
            navigate("/");
        }
        setActiveMenuId(200005)
        setActiveMenuObj({
            "Client Management": false,
            "Contact Management": false,
            "Reports": false
        })
        setRoute("user")
        if (id) {
            getuser();


        }
        getAllRegisteredUsers();
        // getManagers();
        //  GetCountries();
        // userActivity();
    }, []);

    useEffect(() => {
        if (editUser?.sendEmailTo?.length > 0 && recipientOptions.length > 0) {
            const preselected = recipientOptions.filter(opt => editUser.sendEmailTo.includes(opt.value));
            setSelectedRecipients(preselected);
            setSelectAll(preselected.length === recipientOptions.length);
        }
    }, [editUser, recipientOptions]);

    useEffect(() => {
        if (editUser?.userType) {
            const rawTypes = Array.isArray(editUser.userType) ? editUser.userType : [editUser.userType];
            const hydrated = rawTypes.filter(Boolean).map(val => (
                USERTYPE_OPTIONS.find(opt => opt.value === val) || { value: val, label: val }
            ));
            setSelectedUserTypes(hydrated);
        }
    }, [editUser]);

    const handleUserTypeChange = (selected) => {
        const values = selected || [];
        setIdcError("");
        setTypeError("");
        setSelectedUserTypes(values);
        if (id) {
            setCheckStatus(true);
        }
        setEditUser(prev => ({ ...prev, userType: values.map(opt => opt.value) }));
    }

    const isValidNewUserTypeOption = (inputValue) => inputValue.includes(".com");

    const getAllRegisteredUsers = () => {
        axios({
            method: 'GET',
            url: lambda + '/userInfo?appname=' + appname + "&userType=" + "DOCTOR",
        })
            .then(function (response) {
                if (response?.data?.result === "Invalid token or Expired") {
                    setShowSessionPopupup(true)
                } else {
                    const users = Array.isArray(response?.data?.result) ? response.data.result : [];
                    const options = users
                        .map((eachUser) => {
                            const email = Array.isArray(eachUser?.emailid) ? eachUser.emailid.join(', ') : eachUser?.emailid;
                            return email ? { value: email, label: email } : null;
                        })
                        .filter(Boolean);
                    setRecipientOptions(options);
                }
            })
            .catch((err) => {
                console.log('error', err);
            });
    }

    const handleRecipientsChange = (selected) => {
        const values = selected || [];
        setIdcError("");
        setTypeError("");
        if (values.some((opt) => opt.value === SELECT_ALL_VALUE)) {
            setSelectedRecipients(recipientOptions);
            setSelectAll(true);
        } else {
            setSelectedRecipients(values);
            setSelectAll(values.length === recipientOptions.length && recipientOptions.length > 0);
        }
    }

    function onConfirm() {
        GetTimeActivity()
        setSuccess(false);
    };

    const getuser = (e) => {
        GetTimeActivity()
        const token = localStorage.getItem("token")
        axios({
            method: 'GET',
            url: lambda + '/userInfo?appname=' + appname + '&userid=' + id,
        })
            .then(function (response) {
                //  console.log("response", response?.data?.result?.[0]);
                if (response?.data?.result === "Invalid token or Expired") {
                    setShowSessionPopupup(true)
                }
                else {
                    if (response?.data?.result.length > 0) {
                        setEditUser(response?.data?.result?.[0]);
                        if (response?.data?.result?.[0] && response?.data?.result?.[0]?.permissions) {
                            setPermission(response?.data?.result?.[0]?.permissions)
                        }
                    } else {
                        setInvalidContent(true)
                    }
                }
                // getPermissions(response?.data && response?.data?.result && response?.data?.result?.[0] && response?.data?.result?.[0]?.type)
            });
    }
      const handleChangeValues = (value) => {
    const selectedValue = value;

    // setFormVariables((prevFormVariables) => {
    //     if (!prevFormVariables.includes(selectedValue)) {
    //         return [...prevFormVariables, selectedValue];
    //     }
    //     return prevFormVariables;
    // });

    setFormValuesOption(selectedValue);
    setValuesDependency(valueDependency + 1);
  };

  const handleContentChange = (value) => {
    setContentError("");
    setContent(value);
  };

    const onclickInvalid = () => {
        GetTimeActivity()
        setInvalidContent(false)
        navigate('/users')
    }

    const handleChange = (e) => {
        const { name, value } = e.target;

        if (name === "subjectline") {
            setEmailError("");
        }
        console.log('typeeeeeeeeee', value);
        console.log('nameeeee', name);

        if (name === "usertype") {
            if (id) {
                setCheckStatus(true);
            }
            setEditUser(prev => ({ ...prev, [name]: value }));
        }

        if (name === "phoneNumber") {
            const numericValue = value.replace(/\D/g, "").slice(0, 10);
            setEditUser(prev => ({ ...prev, phoneNumber: numericValue }));
            return;
        }

        else if (name === "manager") {
            for (let key in manager) {
                if (manager.hasOwnProperty(key) && manager[key].userid === value) {
                    setEditUser(prev => ({ ...prev, [name]: value }));
                    break; // No need to continue looping after finding the match
                }
            }
        }

        else if (name === "status") {
            if (id) {
                setCheckStatus(true);
            }
            setEditUser(prev => ({ ...prev, [name]: value }));
        }

        else {
            setEditUser(prev => ({ ...prev, [name]: value }));
        }
    };



    const handleSendEmail = (e) => {
        GetTimeActivity()
        const isValid = formvalidation();
        if (isValid) {
            sendEmail();
        }
    }

    function formvalidation() {
        GetTimeActivity()
        let formIsValid = true;

        if (!editUser?.subjectline || editUser.subjectline.trim() === "") {
            setEmailError("Please enter Subject Line");
            formIsValid = false;
        } else {
            setEmailError("");
        }

        if (selectedRecipients.length === 0 && selectedUserTypes.length === 0) {
            const message = "Please select Send Email To or Add Other Emails";
            setIdcError(message);
            setTypeError(message);
            formIsValid = false;
        } else {
            setIdcError("");
            setTypeError("");
        }

        const isContentEmpty = !content || content.trim() === "" || content === "<p><br></p>";
        if (isContentEmpty) {
            setContentError("Please enter Email Body");
            formIsValid = false;
        } else {
            setContentError("");
        }

        return formIsValid;
    }


   
    console.log('editUser', editUser)
    const sendEmail = async () => {
        setIsLoading(true)
        const isValid = formvalidation();
        if (!isValid) {
            return false
        }
        // GetTimeActivity()   
        let payload = {}
        payload = {
            "subjectline": editUser?.subjectline,
            "body": content,
            "ccemails": selectedUserTypes.map(opt => opt.value),
            "toemailid": selectedRecipients.map(r => r.value),
        }
        const userId = localStorage.getItem("userId")
        axios({
            method: 'POST',
            url: lambda + "/emailmanager?appname=" + appname + "&userid=" + userId,
            data: payload,
        })
            .then(function (response) {
                if (response) {
                    console.log("response?.result", response)
                 if (response?.result === "Invalid token or Expired") {
                        setIsLoading(false)
                        setShowSessionPopupup(true)
                    }
                    else {
                        setIsLoading(false)
                        setSuccess(true);
                        clearForm();
                        // setToastMessage("User Details Created Successfully")
                        // setTimeout(() => {
                        //     navigate("/users"); // Trigger API call AFTER toast is displayed
                        // }, 2000);
                    }
                }

            });

    };

    const clearForm = () => {
        setEditUser({ name: '', phone: '', userType: '', status: '', emailid: '' ,subjectline:""});
        setSelectedRecipients([]);
        setSelectedUserTypes([]);
        setSelectAll(false);
        setContent('');
    };

    const handleHistory = (e) => {
        GetTimeActivity()
            navigate("/emailhistory")
    }





console.log("content",content)

    return (
        <>
            {showSessionPopupup && <SessionPopup />}
            <div id="layout-wrapper">
                <Header />
               <SideMenu />
                <SweetAlert show={invalidContent}
                    custom
                    confirmBtnText="ok"
                    confirmBtnBsStyle="primary"
                    title={"User Not Found"}
                    onConfirm={e => onclickInvalid()}
                >
                </SweetAlert>
                {!invalidContent &&

                    <div className="main-content user-management create-user" id="main-content">
                        <div className="page-content" id="page-content">
                            <div className="container-fluid" id="container-fluid">
                                <div className="row mb-4 breadcrumb" id="breadcrumb-row">
                                    <div className="col-lg-12">
                                        <div className="d-flex align-items-center">
                                            <div className="flex-grow-1">
                                                <h4 className="mb-2 card-title" id="breadcrumb-title"> SEND EMAIL</h4>
                                                <p className="menu-path" id="breadcrumb-path">
                                                    <span>EMAIL MANAGER</span> / <b id="breadcrumb-action">SEND EMAIL</b>
                                                </p>
                                            </div>
                                            <div>
                                                <a id="back-button" onClick={handleHistory} className="stroke-btn-style create-quiz-btn">EMAIL HISTORY</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="create-user-block" id="create-user-block">
                                    {Object.keys(editUser)?.length > 0 ? (
                                        <>
                                            <div className="form-block" id="form-block">
                                                <div className="row">

                                                    <div className="col-lg-6 col-md-12">
                                                        <div className="mb-3 input-field">
                                                            <label className="form_label">FROM EMAIL</label>
                                                            <input id="name" name="name" placeholder="Enter Name" type="text" className="form-control" aria-invalid="false" value="admin@dermpathacademy.in" readOnly />
                                                        </div>
                                                    </div>


                                                    <div className="col-lg-6 col-md-12">
                                                        <div className="mb-3 input-field">
                                                            <label className="form_label">SUBJECT LINE<span className="required">*</span></label>
                                                            <input id="subjectline" name="subjectline" placeholder="Enter subjectline" type="text" className="form-control" aria-invalid="false" value={editUser?.subjectline} 
                                                            onChange={(e) => handleChange(e)} />
                                                            <span id="email-error" className="errormsg" style={{ fontWeight: 'bold', color: 'red' }}>{emailError}</span>
                                                        </div>

                                                    </div>
                                                    {/* <div className="col-lg-6 col-md-12"></div> */}
                                                    <div className="col-lg-6 col-md-12">
                                                        <div className="mb-3 input-field">
                                                            <label className="form_label">SEND EMAIL TO</label>
                                                            <div>
                                                                <Select
                                                                    id="send-email-to"
                                                                    isMulti
                                                                    value={selectedRecipients}
                                                                    options={[{ value: SELECT_ALL_VALUE, label: "Select All" }, ...recipientOptions]}
                                                                    onChange={handleRecipientsChange}
                                                                    placeholder="Select Users"
                                                                    classNamePrefix="my-select"
                                                                />
                                                                <span id="idc-error" className="errormsg" style={{ fontWeight: 'bold', color: 'red' }}>{IdcError}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {/* <div className="col-lg-6 col-md-12"></div> */}
                                                    <div className="col-lg-6 col-md-12">
                                                        <div className="mb-3 input-field">
                                                            <label className="form_label" htmlFor="usertype-select">
                                                                ADD OTHER EMAILS<span className="required">*</span>
                                                            </label>
                                                            <CreatableSelect
                                                                id="usertype-select"
                                                                className="capitalize"
                                                                classNamePrefix="my-select"
                                                                isMulti
                                                               
                                                                value={selectedUserTypes}
                                                                options={USERTYPE_OPTIONS}
                                                                onChange={handleUserTypeChange}
                                                                isValidNewOption={isValidNewUserTypeOption}
                                                                
                                                            />
                                                            <span
                                                                id="usertype-error"
                                                                className="errormsg"
                                                                style={{ fontWeight: 'bold', color: 'red' }}
                                                            >
                                                                {typeError}
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                             <div className="row">
                                                <div className="col-md-12">
                                                      <label className="form_label" htmlFor="usertype-select">
                                                                        EMAIL BODY
                                                                    </label>
                                                                     <ValuesDropdown onChange={handleChangeValues} />
                                                     <EditorEdit
                                  content={content}
                                  setContent={handleContentChange}
                                  name="template"
                                  formValuesOption={formValuesOption}
                                  valueDependency={valueDependency}
                                />
                                <span id="content-error" className="errormsg" style={{ fontWeight: 'bold', color: 'red' }}>{contentError}</span>
                                                    </div>
                                                </div>

                                            <div className="row mt-2">
                                                <div className="col-md-12">
                                                    <button
    id="submit-button"
    className="fill-btn-style create-quiz-btn border-0"
    type="submit"
    style={{
        cursor: isLoading ? "not-allowed" : "pointer"
    }}
    onClick={e => handleSendEmail(e)}
>
    {isLoading && (
        <img
            src={rotate_right}
            className="loading-icon"
            id="loginPwdLoading"
            alt="loading"
        />
    )}
    SEND EMAIL 
</button>

                                                </div>
                                                {msg && <span id="success-msg" className="errormsg" style={{ fontWeight: 'bold', color: 'green' }}>{msg}</span>}
                                            </div>
                                        </>
                                    ) : (
                                        <div className="form-block" id="loading-block">
                                            <div className="tab-content p-3 text-muted">
                                                <div className="tab-pane active show" id="home1" role="tabpanel">
                                                    <div className="row">
                                                        <Loader />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>

                }



            </div>
            <ToastContainer
                id="toastContainer"
                position="bottom-center"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover={false}
                theme="light"
            />

            <SweetAlert
                show={existmsg}
                custom
                confirmBtnText="ok"
                confirmBtnBsStyle="primary"
                title={"Email already exists"}
                onConfirm={e => setExistMsg(false)}
                id="error-alert"
            ></SweetAlert>
            <SweetAlert
                show={success}
                custom
                confirmBtnText="ok"
                confirmBtnBsStyle="primary"
                title="Email sent successfully"
                onConfirm={e => onConfirm()}
                id="error-alert"
            ></SweetAlert>



        </>
    );
};

export default EditEmailTemplate;